// What the phones show besides the chat, as the panel left it: the scoreboard of the team
// games and the draws (the Sorteos tab). Everything shows until the panel hides something

// (the stopwatch came later, in the middle of an event: it shows once the panel says so)
export const EMPTY_DISPLAY = { scoreboard: true, games: true, stopwatch: false, version: 0 };

// Every change reaches the room as an `app:DISPLAY` event with both pieces, as text
export const displayFromEvent = ({ attributes }) => ({
  scoreboard: attributes.scoreboard !== '0',
  games: attributes.games !== '0',
  stopwatch: attributes.stopwatch === '1',
  version: Number(attributes.version) || 0,
});

// What shows after hearing `incoming` (from the room, /history or the panel API). Every
// change bumps the version, so an older one that arrives late never wins. A backend that
// does not know about this yet sends nothing, and everything keeps showing
export const withDisplay = (current, incoming) => {
  if (!incoming || !(incoming.version > current.version)) return current;
  return { scoreboard: incoming.scoreboard !== false, games: incoming.games !== false, stopwatch: incoming.stopwatch === true, version: incoming.version };
};
